import { render, staticRenderFns } from "./powerfailure.vue?vue&type=template&id=6c39fb6a&"
import script from "./powerfailure.vue?vue&type=script&lang=ts&"
export * from "./powerfailure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports